import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer } from 'react';

// third-party
import { useDispatch } from 'store';

// reducer - state management
import { LOGIN, LOGOUT } from 'store/actions';
import accountReducer from 'store/accountReducer';

// project imports
import Loader from 'ui-component/Loader';
import AuthService from 'services/AuthService';
import { getProfile } from 'store/slices/user';

// constant
const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    user: null
};

const setUserData = async () => {
    let profile = await AuthService.getLoginDetails();
    return profile.data;
};

const JWTContext = createContext(null);

const userData = async (dispatch, dispatchRedux) => {
    try {
        const accessToken = localStorage.getItem('access_token');
        if (!accessToken) {
            dispatch({
                type: LOGOUT
            });
            return;
        }
        const resp = await AuthService.getLoginDetails();
        let profile = resp.data;
        dispatchRedux(getProfile(profile));
        const user = profile;
        dispatch({
            type: LOGIN,
            payload: {
                isLoggedIn: true,
                user
            }
        });
    } catch (err) {
        console.error(err);
        dispatch({
            type: LOGOUT
        });
    }
};

export const JWTProvider = ({ children }) => {

    const [state, dispatch] = useReducer(accountReducer, initialState);

    const dispatchRedux = useDispatch();

    useEffect(() => {
        userData(dispatch, dispatchRedux);
    }, []);

    const setToken = async (data) => {
        const user = data.account;
        localStorage.setItem('access_token', data.accessToken);
        localStorage.setItem('refresh_token', data.refreshToken);
        let profile = await setUserData();
        return {
            profile, user
        };
    };

    const login = async (data) => {
        const res = await AuthService.login(data);
        const tokenResp = await setToken(res.data);
        dispatchRedux(getProfile(tokenResp.profile));
        dispatch({
            type: LOGIN,
            payload: {
                isLoggedIn: true,
                user: tokenResp.user
            }
        });
        return res;
    };

    const logout = () => {
        window.localStorage.clear();
        window.location.href = '/login';
        dispatch({ type: LOGOUT });
    };

    if (state.isInitialized !== undefined && !state.isInitialized) {
        return <Loader />;
    }

    return (
        <JWTContext.Provider
            value={{ ...state, login, logout }}
        >
            {children}
        </JWTContext.Provider>
    );

};

JWTProvider.propTypes = {
    children: PropTypes.node
};

export { userData };

export default JWTContext;
